import { acceptedPaymentMethod } from '../types/customer.types';

export function getDefaultPaymentMethod(
  acceptedPaymentMethods: acceptedPaymentMethod[],
  skipPreselect: boolean
): acceptedPaymentMethod {
  if (skipPreselect) return null;

  return acceptedPaymentMethods.includes('credit_card')
    ? 'credit_card'
    : acceptedPaymentMethods[0] ?? null;
}
